import React from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import util from "../../../../../utils/miniUtils";

export default function ProductFormFields( { product, onProductChange, locations = [] } ) {
    return (
        <>
            <div className="row mb-2">
                <div className="col-md-3 fw-bold">ID</div>
                <div className="col-md-9">
                    {
                        product.id ?
                            <input value={util.zeroPad( product.id, 5 )} disabled className="form-control"/>
                            :
                            "N/A"
                    }
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-3 fw-bold">Articulo *</div>
                <div className="col-md-9">
                    <input 
                        onChange={onProductChange} 
                        value={product.article}
                        name="article" 
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-3 fw-bold">Descripción *</div>
                <div className="col-md-9">
                    <textarea 
                        onChange={onProductChange} 
                        rows={4}
                        name="description" 
                        className="form-control"
                        value={product.description}
                    />
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-3 fw-bold">Local de pertenencia *</div>
                <div className="col-md-9">
                    <select
                        value={product.location_id ? product.location_id : ""}
                        onChange={onProductChange}
                        className="form-control"
                        name="location_id"
                    >
                        <option value="">Selecciona un local...</option>
                        {Array.isArray( locations )
                            ? locations.map( ( loc ) => (
                                <option key={loc.id} value={loc.id}>{loc.name}</option>
                            ) )
                            : null}
                    </select>
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-3 fw-bold">Link Mercado Libre *</div>
                <div className="col-md-9">
                    <input
                        onChange={onProductChange}
                        name="internal_id"
                        className="form-control"
                        value={product.internal_id}
                    />
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-md-3 fw-bold">ML - Item ID</div>
                <div className="col-md-9">
                    <input
                        disabled
                        value={util.showItemId( product.internal_id )}
                        onChange={onProductChange}
                        name="internal_id"
                        className="form-control"
                    />
                </div>
            </div>

           

            <div className="row mb-2">
                <div className="col-md-3 fw-bold d-flex align-items-center justify-content-between">Cantidad *</div>
                <div className="col-md-9">
                    <InputGroup className="">
                        <InputGroup.Text id="basic-addon1">Pza</InputGroup.Text>
                        <FormControl
                            className="text-center"
                            onChange={onProductChange}
                            type="number"
                            name="qty"
                            value={product.qty ? product.qty : ""}
                        />
                    </InputGroup>
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-3 fw-bold d-flex align-items-center justify-content-between">Precio *</div>
                <div className="col-md-9">
                    <InputGroup className="">
                        <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                        <FormControl
                            onChange={onProductChange}
                            className="text-center"
                            type="number"
                            name="price"
                            value={product.price ? product.price : ""}
                        />
                    </InputGroup>
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-3 fw-bold d-flex align-items-center justify-content-between">Del Año</div>
                <div className="col-md-9">
                    <select 
                        value={product.year ? product.year : ""} 
                        onChange={onProductChange} 
                        className="form-control" 
                        name="year">
                        <option value="0"> -- </option>
                        {
                            util.listOfYears().map( ( y, i ) => {
                                return <option key={i} value={y}>{y}</option>;
                            } )
                        }
                    </select>
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-3 fw-bold d-flex align-items-center justify-content-between">Hasta Año</div>
                <div className="col-md-9">
                    <select 
                        value={product.year_end ? product.year_end : ""} 
                        onChange={onProductChange} 
                        className="form-control" 
                        name="year_end">
                        <option value="0"> -- </option>
                        {
                            util.listOfYears().map( ( y, i ) => {
                                return <option key={i} value={y}>{y}</option>;
                            } )
                        }
                    </select>
                </div>
            </div>
        </>
    );
}
